function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Wrapper for the Console for use in a golden layout container
// Will probably need to handle window popping out from golden layout here.
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { LogView } from '@deephaven/console';
import Log from '@deephaven/log';
import "./LogPanel.css";
import Panel from "./CorePanel.js";
import { getDashboardSessionWrapper } from "../redux/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('LogPanel');
class LogPanel extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "isBottomVisible", void 0);
    _defineProperty(this, "logView", void 0);
    this.handleResize = this.handleResize.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.handleSessionOpened = this.handleSessionOpened.bind(this);
    this.handleSessionClosed = this.handleSessionClosed.bind(this);
    this.isBottomVisible = true;
    this.logView = null;
    var session = this.props.session;
    this.state = {
      session
    };
  }
  handleResize() {
    this.updateDimensions();
  }
  handleShow() {
    this.updateDimensions();
    if (this.logView) {
      this.logView.triggerFindWidget();
      if (this.isBottomVisible) {
        this.logView.scrollToBottom();
      }
    }
  }
  handleHide() {
    if (this.logView) {
      this.isBottomVisible = this.logView.isBottomVisible();
    }
  }
  handleSessionOpened(_ref) {
    var session = _ref.session;
    log.debug('Session opened', [session]);
    this.setState({
      session
    });
  }

  // eslint-disable-next-line class-methods-use-this
  handleSessionClosed(session) {
    log.debug('Session closed', session);
    // Keep the session reference in state unchanged until the session is re-connected
  }
  updateDimensions() {
    if (this.logView) {
      this.logView.updateDimensions();
    }
  }
  render() {
    var _this$props = this.props,
      glContainer = _this$props.glContainer,
      glEventHub = _this$props.glEventHub;
    var session = this.state.session;
    return /*#__PURE__*/_jsxs(Panel, {
      componentPanel: this,
      glContainer: glContainer,
      glEventHub: glEventHub,
      onResize: this.handleResize,
      onHide: this.handleHide,
      onShow: this.handleShow,
      onSessionOpen: this.handleSessionOpened,
      onSessionClose: this.handleSessionClosed,
      children: [session == null && /*#__PURE__*/_jsx("div", {
        className: "log-panel-disconnected-message",
        children: "Waiting for session connection"
      }), session != null && /*#__PURE__*/_jsx(LogView, {
        session: session,
        ref: logView => {
          this.logView = logView;
        }
      })]
    });
  }
}
_defineProperty(LogPanel, "defaultProps", {
  session: null
});
_defineProperty(LogPanel, "COMPONENT", 'LogPanel');
_defineProperty(LogPanel, "TITLE", 'Log');
var mapStateToProps = (state, ownProps) => {
  var _getDashboardSessionW;
  return {
    session: (_getDashboardSessionW = getDashboardSessionWrapper(state, ownProps.localDashboardId)) === null || _getDashboardSessionW === void 0 ? void 0 : _getDashboardSessionW.session
  };
};
var ConnectedLogPanel = connect(mapStateToProps, null, null, {
  forwardRef: true
})(LogPanel);
export default ConnectedLogPanel;
//# sourceMappingURL=LogPanel.js.map